<div class="slider-box">
  <div class="slider-header">
    <div class="slider-header__icon">
      <img [src]="'assets/svg/o-' + preferenceSlider.icon + '.svg'" [alt]="preferenceSlider.value" />
    </div>
    <div class="slider-header__title">{{preferenceSlider.name}}</div>
  </div>

  <div class="slider-wrapper">
    <div class="slider-wrapper__track">
      <div #fillTrackRef class="slider-wrapper__track--fill"></div>
    </div>

    <input
        class="slider-wrapper__slide"
        type="range"
        min="0"
        max="10"
        step="1"
        (mouseup)="onMouseUp()"
        (mousedown)="onMouseDown()"
        (touchstart)="onTouchStart()"
        (touchend)="onTouchEnd()"
        [value]="preferenceSlider.value"
        [(ngModel)]="preferenceSlider.value"
    />
  </div>
</div>
